
import {initWebComponent} from "@/helpers/web-component-helper";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {applyFilter} from "@/helpers/filter/filter-helper";

export class LayerInfoFilterResultButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<a href="#" class="text-secondary">Resultaat</a>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            this.firstChild.classList.add('font-weight-bold')

            applyFilter()
        })
    }
}

